import { useCallback } from 'react';

import { EditableRequirement } from '../../types';
import { useCriteriaState } from './useCriteriaState';

export const useCriteriaRequirementsState = () => {
  const {
    criteria: { searchQueries: requirements = [] },
    setCriteria,
  } = useCriteriaState();
  const setRequirements = useCallback(
    (setterFn: (currentRequirements: EditableRequirement[]) => EditableRequirement[]) =>
      setCriteria((criteria) => ({
        ...criteria,
        searchQueries: setterFn(criteria.searchQueries ?? []),
      })),
    [setCriteria],
  );
  return { requirements, setRequirements };
};
